import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { MembershipPopover } from "@silvertours/front-entities";
import { useLogin } from "@silvertours/front-features";
import { Button, Ui } from "@silvertours/front-shared";
import { LockIcon, UserIcon, MembershipPanelWrapper } from "./LoginButton.styles";
import { LoggedInActions } from "../LoggedInActions";
var LoginButton = function(param) {
    var onClick = param.onClick, translations = param.translations;
    var ref = useLogin(), isLoggedIn = ref.isLoggedIn, setShowLogin = ref.setShowLogin;
    var membership = translations.membership;
    var handleLoginClick = function() {
        if (typeof onClick === "function") {
            onClick();
        }
        setShowLogin(true);
    };
    var handleSignUpClick = function() {
        window.location.assign(membership.signUpLink);
    };
    if (!isLoggedIn) {
        return /*#__PURE__*/ _jsx(Ui.Popover, {
            button: {
                as: "div",
                children: /*#__PURE__*/ _jsx(Button, {
                    icon: /*#__PURE__*/ _jsx(LockIcon, {}),
                    variant: "secondary",
                    size: "small",
                    children: translations.label
                })
            },
            triggerAction: "click",
            children: /*#__PURE__*/ _jsx(Ui.PopoverPanel, {
                children: /*#__PURE__*/ _jsx(Ui.PanelContentWrapper, {
                    width: "403px",
                    children: /*#__PURE__*/ _jsx(MembershipPanelWrapper, {
                        children: /*#__PURE__*/ _jsx(MembershipPopover, {
                            translations: membership,
                            handleLoginClick: handleLoginClick,
                            handleSignUpClick: handleSignUpClick
                        })
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ _jsx(Ui.Popover, {
        button: {
            as: "div",
            children: /*#__PURE__*/ _jsx(Button, {
                icon: /*#__PURE__*/ _jsx(UserIcon, {}),
                variant: "secondary",
                size: "small",
                children: translations.account
            })
        },
        triggerAction: "click",
        children: /*#__PURE__*/ _jsx(Ui.PopoverPanel, {
            children: /*#__PURE__*/ _jsx(LoggedInActions, {
                translations: translations
            })
        })
    });
};
export { LoginButton };
